import script from "./SideBarReordering.vue?vue&type=script&setup=true&lang=js"
export * from "./SideBarReordering.vue?vue&type=script&setup=true&lang=js"

import "./SideBarReordering.vue?vue&type=style&index=0&id=a92dafac&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a92dafac"]])

export default __exports__